import { createFeatureSelector, createSelector } from '@ngrx/store';
import {StoreKeys} from '../../models/store-keys';
import { CacheFormState } from './cache/reducer/cache-form.reducer';


export const selectCacheFormFeature = createFeatureSelector<CacheFormState>(StoreKeys.CACHE_FORM);
export const selectCacheFormDatas = createSelector( selectCacheFormFeature, state => state.datas);
